"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandingCard = void 0;
var Utilities_1 = require("../../Utilities");
var ExpandingCard_styles_1 = require("./ExpandingCard.styles");
var ExpandingCard_base_1 = require("./ExpandingCard.base");
exports.ExpandingCard = Utilities_1.styled(ExpandingCard_base_1.ExpandingCardBase, ExpandingCard_styles_1.getStyles, undefined, {
    scope: 'ExpandingCard',
});
//# sourceMappingURL=ExpandingCard.js.map